import { useHistory, useLocation } from "react-router-dom";
import {PageHeader} from "antd"
export default function HeaderPage() {
    const location = useLocation().pathname;
    const history = useHistory();
    return(
        <>
        {location !== "/home" &&
      location !== "/" &&
      location !== "/register" &&
      location !== "/page-not-found" ? (
        <PageHeader
          //style={{ backgroundColor: "white" }}
          onBack={() => {
            history.goBack();
          }}
          title="Atras"
          subTitle=""
        />
      ) : null}
        </>
    )
}